import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Plus",
  "use": "Plus-usage",
  "viewBox": "0 0 33 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 32\" id=\"Plus\"><path fill-rule=\"evenodd\" d=\"M19.6 13.113V.25h-5.776v12.863H.962v5.774h12.862V31.75H19.6V18.887h12.863v-5.774H19.599z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol